const deliveryFaqModal = document.querySelector('.delivery-faq-modal')
const deliveryFaqButton = document.querySelector(
  '#delivery-faq-button'
)
const deliveryFaqClose = document.querySelector('#delivery-faq-modal--close')

deliveryFaqButton.addEventListener('click', () => {
  deliveryFaqModal.classList.toggle('show')
})
deliveryFaqClose.addEventListener('click', () => {
  deliveryFaqModal.classList.remove('show')
})

this.addEventListener('keydown', (event) => {
  if (event.code.toUpperCase() === 'ESCAPE')
  deliveryFaqModal.classList.remove('show')
})

const sizeChartModal = document.querySelector('.size-chart-modal');
const sizeChartButton = document.querySelector('.product-form__input__legend > span');
const sizeChartClose  = document.querySelector('#size-chart-modal--close');

if (sizeChartButton && sizeChartModal) {
  sizeChartButton.addEventListener('click', () => {
    sizeChartModal.classList.toggle('show');
  });
}

if (sizeChartClose && sizeChartModal) {
  sizeChartClose.addEventListener('click', () => {
    sizeChartModal.classList.remove('show');
  });
}

if (sizeChartModal) {
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.code === 'Escape') {
      sizeChartModal.classList.remove('show');
    }
  });
}

const pdpVideoPlay = document.querySelector('#pdp-video-play')
const pdpVideoElement = document.querySelector('#pdp-video-element')

if (pdpVideoPlay && pdpVideoElement) {
  pdpVideoPlay.addEventListener('click', () => {
    pdpVideoElement.play();
    pdpVideoPlay.classList.add('hide-button');
  })

  pdpVideoElement.addEventListener("ended", (event) => {
    pdpVideoPlay.classList.remove('hide-button');
  });
}

const showHideFixedAddToCart = () => {

  const fixedAddCart = document.querySelector('.mobile-add-cart-btn');
  const standardAddCart = document.querySelector('.default-add-cart-btn');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fixedAddCart.classList.add('hide-btn');
      } else {
        fixedAddCart.classList.remove('hide-btn');
      }
    });
  });

  if (window.innerWidth < 751) {
    observer.observe(standardAddCart);
  } else {
    observer.unobserve(standardAddCart);
  }

}

showHideFixedAddToCart();

// Apply padding-right to the last media item based on #product-information width (desktop only)
(() => {
  // Adjust to your theme's desktop breakpoint
  const mql = window.matchMedia('(min-width: 990px)');

  const getInfo = () => document.getElementById('product-information');
  const getMediaList = () => document.querySelector('.product__media-list');
  const getLastItem = () =>
    document.querySelector('.product__media-list .product__media-item:last-of-type') ||
    document.querySelector('.product__media-list .product__media-item:last-child');

  let active = false;
  let scheduled = false;
  let ro = null; // ResizeObserver
  let mo = null; // MutationObserver

  const sectionEvents = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect'];
  const onResize = () => scheduleApply();
  const onOrientation = () => scheduleApply();
  const onSection = () => { scheduleApply(); wireObservers(); };

  const scheduleApply = () => {
    if (!active) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const apply = () => {
    if (!active) return;
    const info = getInfo();
    const target = getLastItem();
    if (!info || !target) return;

    const width = Math.round(info.getBoundingClientRect().width || info.offsetWidth || 0);
    target.style.paddingRight = width ? `${width}px` : '';

    console.log('width: ' + width)
  };

  const wireObservers = () => {
    if (!active) return;

    // Disconnect any previous observers
    if (ro) { ro.disconnect(); ro = null; }
    if (mo) { mo.disconnect(); mo = null; }

    const info = getInfo();
    if (info && 'ResizeObserver' in window) {
      ro = new ResizeObserver(() => scheduleApply());
      ro.observe(info);

      // If images inside product info load later, they can affect width
      info.querySelectorAll('img').forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', scheduleApply, { once: true });
          img.addEventListener('error', scheduleApply, { once: true });
        }
      });
    }

    const list = getMediaList();
    if (list && 'MutationObserver' in window) {
      mo = new MutationObserver(() => scheduleApply());
      mo.observe(list, { childList: true });
    }
  };

  const start = () => {
    if (active) return;
    active = true;

    // Initial apply once DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
    } else {
      scheduleApply();
    }
    window.addEventListener('load', scheduleApply);
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onOrientation);
    sectionEvents.forEach(evt => window.addEventListener(evt, onSection));

    wireObservers();
  };

  const stop = () => {
    if (!active) return;
    active = false;

    // Tear down observers/listeners
    if (ro) { ro.disconnect(); ro = null; }
    if (mo) { mo.disconnect(); mo = null; }

    window.removeEventListener('load', scheduleApply);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onOrientation);
    sectionEvents.forEach(evt => window.removeEventListener(evt, onSection));

    // Clear any inline padding that was set for desktop
    const target = getLastItem();
    if (target) target.style.paddingRight = '';
  };

  // Respond to breakpoint changes
  const handleMql = e => {
    if (e.matches) start();
    else stop();
  };

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', handleMql);
  } else if (typeof mql.addListener === 'function') {
    // Safari fallback
    mql.addListener(handleMql);
  }

  // Initial state
  if (mql.matches) start();
  else stop();
})();


// Might use later for PDP product image on desktop

// $(function() {
//   var maxL = 5;
//   //set you number to show
//   var listItems = jQuery('.product__media-list li').length;
//   // get curent number of items
//   if (listItems > maxL) {
//     // if curent number is biger then wanted
//     $('.product__media-list li:nth-child(+n+' + (maxL + 1) + ')').addClass("hide-content")
//     //find all li items after set crop number
//     $('<li><span class="dots">...CLICK</span></li>').insertAfter($('.product__media-list li:last-child'));
//     //add span with dots or whatever
//   }

// });


// $(document).on("click", ".dots", function() {
//   // on click of dots remove hidden class and remove dots parent li element
//   $('.product__media-list').find(".hide-content").removeClass("hide-content")
//   $('.product__media-list').find(".dots").parent("li").remove()
// });
